import { createContext }	from "preact";
import { useContext }		from "preact/hooks";

import { Sets }				from "ts-base/sets";

import { Permission }		from "@v3/data/permission";

const Context	= createContext<ReadonlySet<Permission>>(Sets.empty());

export const ProvidePermissions	= Context.Provider;

export const usePermissions	= ():ReadonlySet<Permission> => useContext(Context);
